import { AssistentItem } from '../assistent_config';
import { IDs } from '../../../../helpers/IDs';
import React from 'react';
import { StructureService } from '../../../../services/structure_service';
import { TriggerService } from '../../../../core/trigger/trigger_service';

export function getVsmeBasisEntitiesOld(data?: any) {
    const b1: any = ((data || {})[IDs.ENT_VSME_B1] || [])[0] || {};
    const group = 'vsme_basis';
    const infoTextStyle = { maxWidth: 600 };
    const includePatModul = Object.keys(b1).length ? (b1.modul === 'basis_pat' || b1.modul === 'basis_pat_geschaeft') : true;
    return [
        { gliederung: '2.', gliederung2: 'I.', collapsible: group, name: 'Basismodul (Metrics)', infoTextKey: 'hinweis_vsme_basis' },
        {
            gliederung: '2.1', gliederung2: 'B1:', key: IDs.ENT_VSME_B1, group, collapsible: 'vsme_basis_b1', name: 'Konfigurationsfragen', singleItem: true,
            disableIndicator: true
        },
        {
            gliederung: '2.2', key: IDs.ENT_VSME_B2, group, singleItem: true,
            ...(includePatModul ? { type: 'CustomElement', infoTextKey: 'hinweis_vsme_basis_b2_b' } : { infoTextKey: 'hinweis_vsme_basis_b2', infoTextStyle })
        },
        { gliederung: '2.3', key: IDs.ENT_VSME_B3, group, singleItem: true, collapsible: 'vsme_basis_b3', infoTextKey: 'hinweis_vsme_basis_b3', infoTextStyle },
        // { gliederung: '2.3', key: IDs.ENT_VSME_B3, group, collapsible: 'vsme_basis_b3', type: 'CustomElement', infoTextKey: 'hinweis_vsme_basis_b3' },
        { gliederung: '2.4', key: IDs.ENT_VSME_B4, group, infoTextKey: 'hinweis_vsme_basis_b4', infoTextStyle },
        { gliederung: '2.5', key: IDs.ENT_VSME_B5, group, singleItem: true },
        { gliederung: '2.6', key: IDs.ENT_ENERGIEDATEN_WASSER, group, name: 'B6: Wasser' },
        {
            gliederung: '2.6.1', key: IDs.ENT_VSME_B6, group, singleItem: true, name: 'B6.1: Wasserstress', infoTextKey: 'hinweis_vsme_basis_b6.1',
            infoTextStyle, colBg: '#eee'
        },
        { gliederung: '2.7', key: IDs.ENT_VSME_B7, group, singleItem: true },
        { gliederung: '2.7.1', key: IDs.ENT_CO2_SCOPE3_ABFALL, group, name: 'B7.1: Abfall', colBg: '#eee' },
        { gliederung: '2.8', key: IDs.ENT_BETRIEBSDATEN, group, singleItem: true, name: 'B8: Arbeitskräfte: Allgemeine Merkmale' },
        {
            gliederung: '2.8.1', key: IDs.ENT_VSME_B8, group, singleItem: true, name: 'B8.1: Aufschlüsselung', infoTextKey: 'hinweis_vsme_basis_b8.1',
            infoTextStyle, colBg: '#eee'
        },
        { gliederung: '2.9', key: IDs.ENT_VSME_B9, group, singleItem: true },
        { gliederung: '2.10', key: IDs.ENT_VSME_B10, group, singleItem: true, infoTextKey: 'hinweis_vsme_basis_b10', infoTextStyle },
        { gliederung: '2.11', key: IDs.ENT_VSME_B11, group, singleItem: true },
        { gliederung: '2.12', key: IDs.ENT_VSME_B12, group, singleItem: true }
    ];
}

export function getAssistentConfigVsmeBasisItemsOld(data: any, triggerService: TriggerService, structureService: StructureService): AssistentItem[] {
    const ents = getVsmeBasisEntitiesOld(data);
    const items: AssistentItem[] = ents.filter((e: any) => !e.disabled).map((e: any) => {
        if (e.collapsible && !e.key) {
            return {
                collapsible: e.collapsible,
                group: e.group,
                gliederung: e.gliederung,
                gliederung2: e.gliederung2,
                name: e.name,
                style: { backgroundColor: e.colBg || '#616468', color: !e.colBg && 'white' },
                type: 'CustomGroupElement',
                infoTextKey: e.infoTextKey
            };
        }
        const structure = structureService.getStructureByKey(IDs.MOD_ETOOL, e.key) || {};
        return {
            collapsible: e.collapsible,
            group: e.group,
            gliederung: e.gliederung,
            gliederung2: e.gliederung2,
            name: e.name || structure.TITEL,
            colBg: e.colBg,
            dataName: structure.TITEL,
            description: 'Dies ist das Formular zur Eingabe der VSME-Daten.',
            type: e.type || 'EntityForm',
            addLabel: 'Neuen Datensatz erfassen',
            entity: e.key,
            configFlag: 'inputVsmeBasis',
            singleItem: e.singleItem,
            customOnSaveDone: (ent: string, dataItem: any) => {
                triggerService.fire('reload', ent);
            },
            infoTextKey: e.infoTextKey,
            infoTextStyle: e.infoTextStyle,
            disableIndicator: e.disableIndicator,
            extraFormElementAfter: e.extraFormElementAfter
        }
    });
    return items;
}
